import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants, currencyString } from "@qgiv/core-js";
import { getFormattedPrice } from "@qgiv/core-donor";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { setCurrentRegistrationCategory } from "../../../redux/slices/registrationSlice";
import { setAppShowRegistrationRole } from "../../../redux/slices/appSettingsSlice";
import SimpleCategory from "./SimpleCategory";

const ConnectedSimpleCategory = ({ controlId }) => {
    const {
        ENUMS: {
            RegistrationFeeDisplay: { DISPLAY_NOTHING },
            DefaultView,
        },
    } = constants;

    const currency = useSelector((state) =>
        selectSpecificFormSetting(state, "currency"),
    );
    const p2pSettings = useSelector(selectAllP2pSettings);
    const {
        enableIndividualRegistration,
        enableTeams,
        registrationFeeDisplay,
        registrationFeeDisplayText,
    } = p2pSettings;
    const eventEnabledCommitments = !!p2pSettings?.enableCommitments;
    const categories = useSelector(selectAllCategories);
    // Simple category will always be the only category available in store
    const category = categories[0];

    const { earlyRegistration, fee, id, registrationFee, commitmentAmount } =
        category;

    // Infer props from settings
    const isFree = registrationFee === 0;
    const isVisible = isFree
        ? registrationFeeDisplay !== DISPLAY_NOTHING
        : true;

    const formattedPrice = getFormattedPrice(
        registrationFee,
        currency,
        registrationFeeDisplay,
        registrationFeeDisplayText,
    );

    const formattedDiscountedPrice = currencyString(fee, currency);
    const hasDiscount = isFree ? false : earlyRegistration;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_DETAILS_STEP,
            state,
        ),
    );

    const { options = {} } = control;
    const _category = options?.category || {};
    const {
        commitmentLabel = "Commit to raising at least %CommitmentAmount% by %CommitmentDeadline% or cover the difference.",
    } = _category;

    const hasCommitments =
        eventEnabledCommitments && commitmentAmount && commitmentAmount > 0;

    const isRegRoleIndividualOnly =
        enableIndividualRegistration && !enableTeams;
    const isRegRoleTeamOnly = !enableIndividualRegistration && enableTeams;

    const simpleCategoryProps = {
        controlId,
        details: commitmentLabel,
        earlyRegistration,
        hasCommitments,
        enableTeams,
        formattedDiscountedPrice,
        formattedPrice,
        hasDiscount,
        id,
        isFree,
        isRegRoleIndividualOnly,
        isRegRoleTeamOnly,
        isVisible,
        setAppShowRegistrationRole,
        setCurrentRegistrationCategory,
    };
    return <SimpleCategory {...simpleCategoryProps} />;
};

ConnectedSimpleCategory.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedSimpleCategory;
